import React from "react";
import { PackageContainer } from "../components/packageTour/PackageContainer";
import "../components/componentsStyle.scss";

export const PackagesPage = ({ languageId }) => {
  return <PackageContainer languageId={languageId} />;
};
